<template>
    <div class="leads-summary-pane">
        <div v-if="isLoading">
            <ui-progress-circular indeterminate :size="64" :stroke="2" style="margin: 2rem auto 3rem;"></ui-progress-circular>
        </div>
        <div v-else>
            <ul v-if="hasLeads">
                <li class="lead-item" v-for="lead in leads" @click="showLead(lead)">
                    <div>
                        <div style="flex-grow: 1;">
                            <span class="material-icons" style="vertical-align: middle; margin-right: .5rem;">person</span>
                            {{ lead.contact.primary_display_as }}
                        </div>
                        <div>
                            <lead-status-tag :lead="lead"></lead-status-tag>
                        </div>
                    </div>
                    <lead-detail-items v-if="summaryType === 'contact'" :lead="lead"></lead-detail-items>
                    <div style="display: flex; margin-top: .5rem; color: #999; font-size: 14px;">
                        <div style="flex-grow: 1;">
                            <div>
                                <span>{{ lead.referral_source.name }}</span>
                            </div>
                        </div>
                        <div>
                            <avatar v-if="lead.owner" :user="lead.owner" :size="24"></avatar>
                            <span class="material-icons" style="vertical-align: middle; margin-right: .5rem; margin-left: .5rem; padding-left: .5rem; border-left: 1px solid #ccc;">schedule</span>{{ lead.created_at |  waitingSince}}
                        </div>
                    </div>
                </li>
            </ul>

            <div class="text-center" style="padding: 1.5rem 0;" v-else>
                No linked leads
            </div>

            <div style="text-align: center; padding: 0 1rem 1rem;">
                <secondary-pill-button @click="addLead">+ Add Lead</secondary-pill-button>
            </div>
        </div>

        <!-- New Lead Modal !-->
        <new-lead-modal ref="newLead" @saved="triggerUpdate()" :defaults="mergedLeadDefaults"></new-lead-modal>

        <!-- Existing Lead Modal !-->
        <existing-lead-side-modal @updated="triggerUpdate()" ref="existingLead"></existing-lead-side-modal>
    </div>
</template>

<script>
import {LeadDetailTypes, LeadResource, LeadTypes} from "../../classes/Api/Lead";
import LeadDetailItems from "./LeadDetailItems";
import LeadStatusTag from "./LeadStatusTag";
import Filters from "../../filters"
import ExistingLeadSideModal from "./ExistingLeadSideModal";
import NewLeadModal from "./NewLeadModal";

export default {
    components: {NewLeadModal, ExistingLeadSideModal, LeadStatusTag, LeadDetailItems},
    filters: Filters,
    props: {
        summaryType: {
            type: String,
            required: true
        },
        summaryFor: {
            type: Object,
            required: true
        },
        leadDefaults: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            isLoading: true,
            leads: []
        }
    },
    mounted() {
        this.load()
    },
    computed: {
        hasLeads() {
            return this.leads.length > 0
        },
        mergedLeadDefaults() {
            if (this.summaryType === 'contact') {
                return {
                    ...this.leadDefaults,
                    contact: this.summaryFor,
                    contact_id: this.summaryFor.id,
                    type: LeadTypes.SALES
                }
            } else if (this.summaryType === 'vehicle') {
                return {
                    ...this.leadDefaults,
                    vehicles_of_interest: [this.summaryFor],
                    type: LeadTypes.SALES
                }
            }
        }
    },
    methods: {
        load() {
            let filters = {}

            if (this.summaryType === 'contact') {
                filters['lead.contact'] = this.summaryFor.id
            } else if (this.summaryType === 'vehicle') {
                filters['lead.vehicle_of_interest'] = this.summaryFor.id
            }

            LeadResource.all({ filters: JSON.stringify(filters), with: JSON.stringify(['notes', 'owner']) }).then(r => {
                this.leads = r.data.results
            }).finally(() => { this.isLoading = false })
        },
        addLead() {
            this.$refs.newLead.open()
        },
        showLead(lead) {
            this.$refs.existingLead.open(lead.id)
        },
        triggerUpdate() {
            this.load()

            this.$emit('updated')
        }
    }
}
</script>

<style lang="scss" scoped>

    ul {
        list-style: none;
        padding: 0;
        margin-bottom: .5rem;
        text-align: left;

        li {
            border-bottom: 1px solid #eee;
            padding: 1rem 1rem .5rem;

            &:first-child { margin-top: 0; padding-top: .5rem; }
            &:last-child { border-bottom: none; padding-bottom: .25rem }

            cursor: pointer;
            user-select:none;

            &:hover { background: #f6f6f6; border-radius: 5px; }

            & > div {
                display: flex;
                margin-bottom: .5rem;
            }
        }
    }
</style>